import React, { useState } from 'react';
import './About.css';

const About = () => {
  const [imageErrors, setImageErrors] = useState(new Set());

  const handleImageError = (imageId) => {
    setImageErrors(prev => new Set(prev).add(imageId));
  };

  // Define image URLs for About page
  const storyImageUrl = "/images/about/nicole-portrait.jpg";
  const equipmentImageUrl = "/images/about/photography-equipment.jpg";
  return (
    <div className="about">
      <div className="about-header">
        <div className="container">
          <h1>About Nicole</h1>
          <p>Passionate about capturing the beauty and innocence of childhood</p>
        </div>
      </div>

      <div className="about-story">
        <div className="container">
          <h2>My Story</h2>
          <div className="story-content">
            <div className="story-text">
              <p>
                With over a decade of experience in children's fashion photography, 
                I've dedicated my career to capturing the unique personality and 
                natural beauty of young models. My journey began with a simple 
                passion for photography and a love for working with children.
              </p>
              <p>
                Each photo session is more than just taking pictures—it's about 
                creating a comfortable, fun environment where children can be 
                themselves. I believe that the best photographs come from genuine 
                moments of joy and confidence.
              </p>
              <p>
                My work has been featured in prestigious magazines and has earned 
                recognition from industry professionals. But the greatest reward 
                is seeing the smiles on children's faces and the pride in their 
                parents' eyes when they see the final images.
              </p>
            </div>
            <div className="story-image">
              {storyImageUrl && !imageErrors.has('story') ? (
                <img 
                  src={storyImageUrl} 
                  alt="Nicole Schweitzer Portrait"
                  className="story-img"
                  onError={() => handleImageError('story')}
                />
              ) : (
                <div className="story-image-placeholder">
                  <span>Nicole Schweitzer</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="about-philosophy">
        <div className="container">
          <h2>My Philosophy</h2>
          <div className="philosophy-grid">
            <div className="philosophy-item">
              <div className="philosophy-icon">🌟</div>
              <h3>Natural Beauty</h3>
              <p>
                I believe every child has natural beauty that shines through when 
                they feel comfortable and confident. My approach focuses on 
                highlighting their unique personality rather than creating 
                artificial poses.
              </p>
            </div>
            <div className="philosophy-item">
              <div className="philosophy-icon">💝</div>
              <h3>Comfort First</h3>
              <p>
                Creating a relaxed, enjoyable environment is key to successful 
                photography. I take the time to build rapport with each child, 
                ensuring they feel safe and happy throughout the session.
              </p>
            </div>
            <div className="philosophy-item">
              <div className="philosophy-icon">🎨</div>
              <h3>Artistic Vision</h3>
              <p>
                Every photograph tells a story. I combine technical expertise with 
                artistic vision to create images that are not just beautiful, but 
                meaningful and memorable for families.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="about-experience">
        <div className="container">
          <h2>Experience & Expertise</h2>
          <div className="experience-grid">
            <div className="experience-item">
              <h3>Children's Fashion Photography</h3>
              <p>
                Specialized in capturing children's clothing and accessories for 
                brands, catalogs, and editorial spreads. Understanding of fashion 
                trends and styling for young models.
              </p>
            </div>
            <div className="experience-item">
              <h3>Modeling Portfolios</h3>
              <p>
                Creating professional portfolios for aspiring child models, 
                highlighting their versatility and natural talent for agencies 
                and casting directors.
              </p>
            </div>
            <div className="experience-item">
              <h3>Editorial Work</h3>
              <p>
                Published work in prestigious magazines, showcasing creative 
                direction and storytelling through children's fashion photography.
              </p>
            </div>
            <div className="experience-item">
              <h3>Commercial Photography</h3>
              <p>
                Experience in advertising campaigns, product photography, and 
                brand collaborations, ensuring high-quality images that meet 
                commercial standards.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="about-equipment">
        <div className="container">
          <h2>Equipment & Expertise</h2>
          <div className="equipment-content">
            <div className="equipment-text">
              <p>
                I use professional-grade equipment to ensure the highest quality 
                images. My photography setup is designed specifically for children's 
                photography, with comfortable seating areas, changing areas, and 
                a variety of backdrops and props.
              </p>
              <p>
                Natural lighting is preferred when possible, but I'm equipped 
                with professional lighting setups for indoor sessions and 
                challenging lighting conditions.
              </p>
              <ul className="equipment-list">
                <li>Professional DSLR cameras</li>
                <li>High-quality lenses for portrait photography</li>
                <li>Professional lighting equipment</li>
                <li>Multiple backdrop options</li>
                <li>Comfortable photography environment</li>
                <li>Props and accessories for styling</li>
              </ul>
            </div>
            <div className="equipment-image">
              {equipmentImageUrl && !imageErrors.has('equipment') ? (
                <img 
                  src={equipmentImageUrl} 
                  alt="Photography Equipment"
                  className="equipment-img"
                  onError={() => handleImageError('equipment')}
                />
              ) : (
                <div className="equipment-image-placeholder">
                  <span>Photography Equipment</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="about-cta">
        <div className="container">
          <h2>Explore My Photography</h2>
          <p>
            Browse through my collection of children's fashion photography and 
            see how I capture the unique personality and style of young models.
          </p>
          <div className="cta-buttons">
            <a href="/gallery" className="btn btn-primary">
              View Gallery
            </a>
            <a href="/achievements" className="btn btn-secondary">
              See Achievements
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
